import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  IconButton,
} from '@material-ui/core'
import { ChevronDown, ChevronUp } from 'react-feather'
import { powerUnit } from '../../../util/formatters'
import { TableHeaderUnitCell } from '../report/TableHeaderUnitCell'
import { ReportDualEnergyAndPowerRow } from '../report/ReportDualEnergyAndPowerRow'
import { formatMonth, getValuesForMonth } from '../../common/util/date-util'
import { TableHeaderTitleCell } from '../report/TableHeaderTitleCell'

export type BoreholeFieldUsageTableProps = {
  harvested: number[]
  wasteInput: number[]
}

export function BoreholeFieldUsageTable({
  harvested,
  wasteInput,
}: BoreholeFieldUsageTableProps): React.ReactElement {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const getUsingValues = (monthIndex?: number) =>
    getValuesForMonth(harvested, monthIndex)
  const getGivingValues = (monthIndex?: number) =>
    getValuesForMonth(wasteInput, monthIndex)

  return (
    <Table>
      <caption>{`* ${t('boreholeField.disclaimer')}`}</caption>
      <TableHead>
        <TableRow>
          <TableHeaderTitleCell title={t('boreholeField.usage')}>
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <ChevronUp /> : <ChevronDown />}
            </IconButton>
          </TableHeaderTitleCell>
          <TableHeaderUnitCell
            firstRow={t('boreholeField.harvestedHeat')}
            secondRow="MWh"
          />
          <TableHeaderUnitCell
            firstRow={t('boreholeField.harvestedHeat')}
            secondRow={powerUnit}
          />
          <TableHeaderUnitCell
            firstRow={t('boreholeField.wasteInputHeat')}
            secondRow="MWh"
          />
          <TableHeaderUnitCell
            firstRow={t('boreholeField.wasteInputHeat')}
            secondRow={powerUnit}
          />
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from(Array(12).keys()).map((monthIndex) => (
          <ReportDualEnergyAndPowerRow
            key={`report-earth-source-month-${monthIndex}`}
            title={formatMonth(monthIndex, t('date.month'))}
            firstResultValues={[getUsingValues(monthIndex)]}
            secondResultValues={[getGivingValues(monthIndex)]}
            show={open}
          />
        ))}
        <ReportDualEnergyAndPowerRow
          title={t('common.total')}
          firstResultValues={[harvested]}
          secondResultValues={[wasteInput]}
          omitPower
          highlightRow
        />
        <ReportDualEnergyAndPowerRow
          title={t('common.max')}
          firstResultValues={[harvested]}
          secondResultValues={[wasteInput]}
          omitEnergy
          highlightRow
        />
      </TableBody>
    </Table>
  )
}
